<template>
  <div>
      <edit-pane v-if="!hidePanel" ref="od" :title="form.name"
      :editable="isManager('project|maintenance|property|finance|management|admin') ? true : false"
      :is-edit="editMode"
      @save="onSave" @cancel="onCancel" @edit="onEdit" @add="onSave" />

      <el-form ref="orgDetailsForm" :model="form" label-width="120px">

        <el-tabs>

          <!-- Main Details Tab -->
          <el-tab-pane>
            <span slot="label"><i class="fa fa-star"></i> Main</span>

            <el-row>

              <el-col :sm="24" :md="12" :lg="12">
                <text-input prop="name" label="Name" required v-model="form.name"
                placeholder="Organisation Name" :disabled="disabled"  />
             </el-col>

             <el-col :sm="24" :md="12" :lg="12">
               <text-input v-model="form.shortName" prop="shortName" label="shortName" required :disabled="disabled" />
             </el-col>

             <el-col v-if="isContractor" :span="24">

                 <el-transfer
                     v-if="!disabled"
                     v-model="subCat"
                     :titles="['All Sub. Cat.', 'Sub. Cat.']"
                     :data="subCatRoles"
                     @change="changeSubCat"
                   />

                 <el-form-item v-else label="Sub Categories">
                   <span  v-for="(role, i) in subCat" :key="i">
                     <el-tag>
                       {{role}}
                     </el-tag>&nbsp;
                   </span>
                 </el-form-item>

             </el-col>

              <el-col :sm="24" :md="12" :lg="8">
                <text-input v-model="form.registrationNo" prop="registrationNo" label="Reg. No." :disabled="disabled" />
              </el-col>

              <el-col :sm="24" :md="12" :lg="8">
                <color-picker v-model="form.colourCode" label="Colour" :disabled="disabled" />
              </el-col>

              <el-col :sm="24" :md="12" :lg="8">
                <check-box v-model="form.canViewAllSites" prop="canViewAllSites" label="" :disabled="disabled">
                  Allow View ALL Sites?
                </check-box>
              </el-col>

              <el-col v-if="form.category === 'Telco'" :sm="24" :md="12" :lg="8">
                <el-tooltip placement="top" content="When checked, users in this Telco can create Request to Backhaul records.">
                  <check-box v-model="form.canCreateRTB" prop="canCreateRTB" label="" :disabled="disabled">
                    Can Create RTB
                  </check-box>
                </el-tooltip>
              </el-col>

          </el-row>

          <el-row>
              <el-col :sm="24" :md="12" :lg="8">
                <text-input v-model="form.phone" prop="phone" label="Phone" :disabled="disabled" />
              </el-col>

              <el-col :sm="24" :md="12" :lg="8">
                <text-input v-model="form.email" prop="email" label="E-Mail" :disabled="disabled" />
              </el-col>

              <el-col :sm="24" :md="12" :lg="8">
                <text-input v-model="form.website" prop="website" label="Web Site" :disabled="disabled" />
              </el-col>

              <el-col :span="24">
                 <text-input type="textarea" :rows="3" v-model="form.address" prop="address" label="Address" :disabled="disabled" />
              </el-col>
            </el-row>

          </el-tab-pane>


         <!-- Sites Tab -->
          <el-tab-pane v-if="!form.canViewAllSites" lazy>
            <span slot="label"><i class="fa fa-broadcast-tower"></i> Sites</span>

            <div v-if="form.category !== 'Contractor'">

              <sites-table :params="{orgId: form.id, orgCategory: form.category}"
               :title="'Sites for ' + (form.shortName ? form.shortName : form.name)"
               :show-status="false" />
            </div>

            <div v-else>
              <org-sites-table :org-id="rowData.id" :category="form.category" />
            </div>

          </el-tab-pane>



          <!-- Contracts Tab -->
          <el-tab-pane lazy>
            <span slot="label"><i class="fa fa-file-alt"></i> Contacts</span>

            <contacts-table :org-id="rowData.id" :org-badge="rowData" />

          </el-tab-pane>



          <!-- Attachments Tab -->
          <el-tab-pane lazy>
            <span slot="label"><i class="fa fa-file-alt"></i> Attachments</span>

            <files-panel
              type="organisation"
              :id="form.id"
             :disabled="disabled" />

          </el-tab-pane>


          <!-- Finance Tab -->
          <el-tab-pane v-if="canAccess('finance')" lazy>
            <span slot="label"><i class="fa fa-university"></i> Financials</span>

            <el-row>
              <el-col :span="12">
                <el-form-item prop="beneficiaryName1" label="Beneficiary #1">
                  <el-input v-model="form.beneficiaryName1" :disabled="disabled" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item prop="beneficiaryName2" label="Beneficiary #2" required>
                  <el-input v-model="form.beneficiaryName2" :disabled="disabled" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item prop="registrationNo1" label="Reg. No. #1">
                  <el-input v-model="form.registrationNo1" :disabled="disabled" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item prop="registrationNo2" label="Reg. No. #2">
                  <el-input v-model="form.registrationNo2" :disabled="disabled" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item prop="bankName1" label="Bank #1">
                  <el-input v-model="form.bankName1" :disabled="disabled" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item prop="bankName2" label="Bank #2">
                  <el-input v-model="form.bankName2" :disabled="disabled" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item prop="bankAccount1" label="Bank Acc. #1">
                  <el-input v-model="form.bankAccount1" :disabled="disabled" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item prop="bankAccount2" label="Bank Acc. #2">
                  <el-input v-model="form.bankAccount2" :disabled="disabled" />
                </el-form-item>
              </el-col>
            </el-row>

          </el-tab-pane>


          <!-- Activities Tab -->
          <el-tab-pane v-if="form.active > 0" lazy>
            <span slot="label"><i class="fa fa-asterisk"></i> Activity</span>

            <el-row :gutter="12" type="flex">

              <el-col v-if="form.stats.sharers > 0">
                <el-card class="semi-transparent" shadow="hover">
                <dash-text caption="Site" icon="fa fa-broadcast-tower" :value="form.stats.sharers" color="darkgrey" />
              </el-card>
              </el-col>

              <el-col v-if="form.stats.actions > 0">
                <el-card class="semi-transparent" shadow="hover">
                  <dash-text caption="Request" icon="fa fa-asterisk" :value="form.stats.actions" color="indianred" />
                 </el-card>
              </el-col>

              <el-col v-if="form.stats.assets > 0">
                <el-card class="semi-transparent" shadow="hover">
                  <dash-text caption="Asset" icon="fa fa-cogs" :value="form.stats.assets" color="slateblue" />
                 </el-card>
              </el-col>

              <el-col v-if="form.stats.backhaul_cust > 0">
               <el-card class="semi-transparent" shadow="hover">
                <dash-text v-if="form.stats.backhaul_cust > 0" caption="Customer" icon="fa fa-wifi" :value="form.stats.backhaul_cust" color="navy" no-plural />
               </el-card>
             </el-col>

             <el-col v-if="form.stats.backhaul_prov > 0">
              <el-card class="semi-transparent" shadow="hover">
               <dash-text v-if="form.stats.backhaul_prov > 0" caption="Provider" icon="fa fa-wifi" :value="form.stats.backhaul_prov" color="navy" no-plural />
              </el-card>
            </el-col>

            <el-col v-if="form.stats.candidate_supplier > 0">
             <el-card class="semi-transparent" shadow="hover">
              <dash-text v-if="form.stats.candidate_supplier > 0" caption="Candidate" icon="fa fa-broadcast-tower" :value="form.stats.candidate_supplier" color="goldenrod" no-plural />
             </el-card>
           </el-col>

           <el-col v-if="form.stats.site_contractor > 0">
            <el-card class="semi-transparent" shadow="hover">
             <dash-text v-if="form.stats.site_contractor > 0" caption="Site Contractor" icon="fa fa-broadcast-tower" :value="form.stats.site_contractor" color="goldenrod" no-plural />
            </el-card>
          </el-col>

            <el-col v-if="form.stats.insurance > 0">
              <el-card class="semi-transparent" shadow="hover">
                <dash-text caption="Insurance" icon="fa fa-shield-alt" :value="form.stats.insurance" color="slategrey" no-plural  />
               </el-card>
            </el-col>

            <el-col v-if="form.stats.permits > 0">
              <el-card class="semi-transparent" shadow="hover">
                <dash-text caption="Permit" icon="fa fa-clipboard" :value="form.stats.permits" color="darkgrey"  />
               </el-card>
            </el-col>

            <el-col v-if="form.stats.structures > 0">
              <el-card class="semi-transparent" shadow="hover">
                <dash-text caption="Structure" icon="fa fa-broadcast-tower" :value="form.stats.structures" color="indigo"  />
               </el-card>
            </el-col>

            <el-col v-if="form.stats.tickets > 0">
              <el-card class="semi-transparent" shadow="hover">
                <dash-text caption="Ticket" icon="fa fa-headset" :value="form.stats.tickets" color="darkorange"  />
               </el-card>
            </el-col>

            <el-col v-if="form.stats.tenancy > 0">
              <el-card class="semi-transparent" shadow="hover">
                <dash-text caption="Tenancy" icon="fa fa-home" :value="form.stats.tenancy" color="darkgreen"  no-plural />
               </el-card>
            </el-col>

            <el-col v-if="form.stats.tickets_cont > 0">
              <el-card class="semi-transparent" shadow="hover">
                <dash-text caption="Contractor" icon="fa fa-headset" :value="form.stats.tickets_cont" color="darkorange"  no-plural  />
               </el-card>
            </el-col>

            <el-col v-if="form.stats.workflow > 0">
              <el-card class="semi-transparent" shadow="hover">
                <dash-text caption="Workflow" icon="fa fa-list" :value="form.stats.workflow" color="indianred" />
               </el-card>
            </el-col>

            </el-row>

            <el-col v-if="isSuper() && !(rowData.category.indexOf('Xolas-Client') > 0)" :span="24" align="center">
             <el-button style="margin-top: 1em;" icon="fa fa-trash"
              @click="deleteEntry()" size="large" type="danger" :disabled="isViewOnly()">
               Delete ALL
             </el-button>
            </el-col>

          </el-tab-pane>


          <!-- Remarks Tab -->
          <el-tab-pane>
            <span slot="label"><i class="fa fa-edit"></i> Remarks</span>

              <html-input v-model="form.remarks"
              label="Remarks"
              :show-empty-message="true"
               :disabled="disabled" />
          </el-tab-pane>


        </el-tabs>

      </el-form>


      <hr style="margin-top: 4.17rem;" />

      <el-row class="bg-bordered" :gutter="16" align="left">
        <el-col :xs="24" :sm="12" :md="8" :lg="8">
          ID: <b>{{form.id}}</b>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="8" align="center">
          <span v-if="form.updated_at">Updated: <b>{{formatDateTime(form.updated_at)}}</b><span v-if="form.updated_by"> by <b>{{form.updated_by}}</b></span></span>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="8" align="right">
          Created: <b>{{formatDateTime(form.created_at)}}</b><span v-if="form.created_by"> by <b>{{form.created_by}}</b></span>
        </el-col>
      </el-row>


  </div>

</template>


<script>

// ALTER TABLE `organisation` ADD COLUMN `remarks` TEXT NULL AFTER `bankAccount3`;

// TODO Allow add organisation

import SiteMixins from '@/mixins/SiteMixins'

import {settings} from '@/components/Data'

import ContactsTable from '@/components/tables/ContactsTable'
import SitesTable from '@/components/tables/SitesTable'
import OrgSitesTable from '@/components/tables/OrgSitesTable'

export default {
  components: {
    ContactsTable,
    OrgSitesTable,
    SitesTable,
  },

  mixins: [SiteMixins],


  props: {

    rowData: {
      type: Object,
      required: true
    },

    siteId: {
      type: Number
    },

    editMode: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'orgtable'
    },

    adding: {
      type: Boolean,
      default: false
    },

    hidePanel: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    changeSubCat (subCatRoles) {
      let cats = ''

      if (subCatRoles.length > 0) {

         for (let s in subCatRoles) {
             cats += (s > 0 ? '|' + this.subCatRoles[s].value : this.subCatRoles[s].value)
           }

         } else {
           cats = this.subCatRoles[0].value
         }

     this.form.subCategory = cats
    },



    resetData () {
      this.form = this.getTableStruct('organisation')
    },



    success (response) {
      this.$events.fire(this.tableRef + '-refresh-table')
    },



    onCancel () {
      this.disabled = true
    },



    onEdit () {
      this.disabled = false
    },



    onAdd () {
      this.disabled = false
      this.onSave()
      this.resetData()
    },



    onSave () {
      this.saveForm(this, '/org', this.form.id, this.form, this.form.name, this.success)
      this.disabled = true
      //      this.resetData()
    },



    onClose () {
      this.resetData()
    },

    deleteEntry () {
      this.deleteItem(this, this.form.id, '/org', this.form.name + ' AND all records in the system associated with this organisation. Are you absolutely sure?', this.onDelete, true, this.tableRef, 'Are very sure?')
    },

    onDelete (response) {
      this.$events.fire(this.tableRef + '-refresh-table')
      this.updateConfig()
      this.$emit('update-stats')

    },

  },



  data () {
    return {
      disabled: true,
      format: settings.selectDateFormat,

      localData: this.rowData,
      isContractor: this.rowData.category === 'Contractor',

      form: this.adding ? this.getTableStruct('organisation') : this.rowData,

      subCat: [],
      subCatRoles: [],

    }
  },


  created () {
    if (this.adding) {
      this.disabled = false
      delete this.form.id
    }

    // Normalise canCreateRTB: treat undefined as true (tolerant of stale
    // session cache before the API column exists). Explicit false survives unchanged.
    if (this.form.canCreateRTB === undefined) {
      this.form.canCreateRTB = true
    }

    let cat = this.getConfig().selects.contractorSubCategory

    if (cat.length > 0) {

      for (let i in cat) {
        this.subCatRoles.push( {key: cat[i].value, label: cat[i].label, value: cat[i].value})
      }
    }

    if (this.form.subCategory) {
      this.subCat = this.form.subCategory.trim().split('|')
    }
  },

}

</script>
